/*
 * Module for the irs 1099r transmit file job criteria page
 */
rs.module("content/jobs/criteria/irs1099rtransmitterfile",

    ["common/select-helper"],

    function (selectHelper) {
        // Initialize the page
        function initialize(jsSelectors, ajaxUrl, recreateOption, fundKey, codevalues) {
            var criteria = $.js(jsSelectors.criteria);
            var fileTypeSelect = criteria.js(jsSelectors.fileTypeSelect);
            var fileCreationDateSelect = criteria.js(jsSelectors.fileCreationDateSelect);
            var fileCreationDateSelectHelper = selectHelper.getHelper(fileCreationDateSelect);
            var taxYearSelect = criteria.js(jsSelectors.taxYearSelect);
            var taxYearSelectHelper = selectHelper.getHelper(taxYearSelect);
            var fileStatusSelect = criteria.js(jsSelectors.fileStatusSelect);
            var fileLayoutSelect = criteria.js(jsSelectors.fileLayoutSelect);
            var reportFormatSelect = criteria.js(jsSelectors.reportFormatSelect);
            var reportFormatSelectHelper = selectHelper.getHelper(reportFormatSelect);
            var testFileIndicator = criteria.js(jsSelectors.testFileIndicator);
            var priorYearIndicator = criteria.js(jsSelectors.priorYearIndicator);
            var payersLastFilingIndicator = criteria.js(jsSelectors.payersLastFilingIndicator);
            var combinedFilerIndicator = criteria.js(jsSelectors.combinedFilerIndicator);

            var initialSelectOptions = taxYearSelectHelper.getOptions();

            setFileIndicatorsDisabled();

            fileTypeSelect.change(setAvailableCreationDates);
            fileStatusSelect.change(function () {
                updateReportFormatSelect();
                setAvailableCreationDates();
            });
            taxYearSelect.change(setAvailableCreationDates);
            fileLayoutSelect.change(function () {
                updateReportFormatSelect();

                var isFireLayout = fileLayoutSelect.val() == codevalues.fire;
                var currentSelectValue = taxYearSelect.val();

                setFileIndicatorsDisabled();

                // Non-FIRE can only use Tax Years of 2022 or later
                if (fileLayoutSelect.val() && !isFireLayout) {
                    var selectOptions = initialSelectOptions.filter(option => option.value >= 2022);
                    taxYearSelectHelper.replaceOptions(selectOptions);
                }
                else {
                    taxYearSelectHelper.replaceOptions(initialSelectOptions);
                }

                // Keep Tax Year selection if possible
                if (fileLayoutSelect.val() != codevalues.yearli || currentSelectValue >= 2022) {
                    taxYearSelectHelper.setValue(currentSelectValue);
                }
            });

            function setAvailableCreationDates() {
                fileCreationDateSelectHelper.setDisabled(fileTypeSelect.val() != recreateOption);
                if (fileTypeSelect.val() == recreateOption) {
                    fileCreationDateSelectHelper.loadOptionsFrom(
                        ajaxUrl,
                        {
                            fundKey: fundKey,
                            taxYear: taxYearSelect.val(),
                            transmitStatus: fileStatusSelect.val()
                        },
                        {
                            withBlank: false
                        });
                } else {
                    fileCreationDateSelectHelper.clearOptions();
                    fileCreationDateSelect.clearErrors();
                }
            }

            function updateReportFormatSelect() {
                // The Report Format picker is only used for Non-FIRE Corrections
                var isNonFireCorrection = fileStatusSelect.val() == codevalues.corrected
                    && (fileLayoutSelect.val() != "" && fileLayoutSelect.val() != codevalues.fire);
                reportFormatSelectHelper.setDisabled(!isNonFireCorrection);

                // Clear report format selection if needed
                if (!isNonFireCorrection) {
                    reportFormatSelect.clearErrors();
                    reportFormatSelectHelper.selectIndex(0);
                }
            }

            // Enable or disable file indicators
            function setFileIndicatorsDisabled() {
                testFileIndicator.setDisabled(fileLayoutSelect.val() == "");
                priorYearIndicator.setDisabled(fileLayoutSelect.val() != codevalues.fire);
                payersLastFilingIndicator.setDisabled(fileLayoutSelect.val() != codevalues.fire);
                combinedFilerIndicator.setDisabled(fileLayoutSelect.val() != codevalues.fire && fileLayoutSelect.val() != codevalues.taxpayerPortal);

                // Uncheck elements that have become unavailable
                $([
                    testFileIndicator,
                    priorYearIndicator,
                    payersLastFilingIndicator,
                    combinedFilerIndicator
                ]).each(function () {
                    $(this).setChecked($(this).prop('checked') && !$(this).prop('disabled'));
                });

            }
        }

        var exports = {
            initialize: initialize
        };

        return exports;
    }
);